<template>
  <div :class="$style.container">
    <div
      v-for="(dayOfWeek, index) in daysOfWeek"
      :key="index"
      :class="$style.cell"
      v-text="$t(dayOfWeek)"
    />
  </div>
</template>

<script>
import { DAYS_OF_WEEK_LIST } from 'definitions/datepicker';

export default {
  name: 'DaysOfWeek',
  data() {
    return {
      daysOfWeek: DAYS_OF_WEEK_LIST,
    };
  },
};
</script>

<style  lang="sass" module>
  .container
    +flexbox

  .cell
    +flex-grow
    +font-type('bold', 14)
    line-height: var(--row-height)
    height: var(--row-height)
    text-align: center
</style>
